module.exports = __webpack_public_path__ + "static/media/photo_3o3_2@3x.aab4273e.png";